namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_settings, {
		
		Stick: {
			flex: {
				grow: 1,
			},
		},

		Overlayed_map_controls: {
			display: 'flex',
			alignItems: 'center',
			padding: {
				top: $mol_gap.block,
			},
		},

		Templates_label: {
			padding: {
				bottom: $mol_gap.block,
			},
		},

		Selfhosted_tauri_config: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.block,
			padding: $mol_gap.block,
		},

		Tauri_port_conflict_message: {
			color: $mol_theme.special,
		},
		
	} )
	
}
